import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetAbilities from './CharacterSheetAbilities.vue';
import CharacterSheetCombat from './CharacterSheetCombat.vue';
import CharacterSheetCasting from './CharacterSheetCasting.vue';
import CharacterSheetEquipment from './CharacterSheetEquipment.vue';
import CharacterSheetDescription from './CharacterSheetDescription.vue';
import CharacterSheetProficiencies from './CharacterSheetProficiencies.vue';
import CharacterSheetNotes from './CharacterSheetNotes.vue';
let CharacterSheetSection = class CharacterSheetSection extends Vue {
    get sections() {
        return [
            {
                component: 'CharacterSheetAbilities',
                icon: 'fa-dice-d20'
            },
            {
                component: 'CharacterSheetCombat',
                icon: 'fa-fist-raised'
            },
            {
                component: 'CharacterSheetCasting',
                icon: 'fa-bolt'
            },
            {
                component: 'CharacterSheetEquipment',
                icon: 'fa-toolbox'
            },
            {
                component: 'CharacterSheetProficiencies',
                icon: 'fa-atlas'
            },
            {
                component: 'CharacterSheetDescription',
                icon: 'fa-user'
            },
            {
                component: 'CharacterSheetNotes',
                icon: 'fa-clipboard'
            }
        ];
    }
};
__decorate([
    Prop(Object)
], CharacterSheetSection.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Number)
], CharacterSheetSection.prototype, "currentTab", void 0);
CharacterSheetSection = __decorate([
    Component({
        components: {
            CharacterSheetAbilities,
            CharacterSheetCombat,
            CharacterSheetCasting,
            CharacterSheetEquipment,
            CharacterSheetDescription,
            CharacterSheetProficiencies,
            CharacterSheetNotes
        }
    })
], CharacterSheetSection);
export default CharacterSheetSection;
